// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__5xQrL","resendInfoText":"OnGoingPaymentBox_resendInfoText__2K6Vm"};